import { DropdownOptionResponse } from '@/@types/responses/common/DropdownOptionResponse'
import { DropdownOptionsResponse } from '@/@types/responses/common/DropdownOptionsResponse'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class StateService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public getStateDropdownOptions(): Promise<DropdownOptionsResponse<DropdownOptionResponse<number>>> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/states/dropdown-options`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as DropdownOptionsResponse<DropdownOptionResponse<number>>
    })
  }
}
